import "../../index91.css";
import { jsxs as _, Fragment as L, jsx as e } from "react/jsx-runtime";
import { useRef as m, useCallback as i } from "react";
import { CheckDoubleFillIcon as me, CloseLineIcon as de, ArrowUpSmallFillIcon as fe, ArrowDownSmallFillIcon as Ce } from "@ifrc-go/icons";
import { b as ge } from "../../core-DVmjA3_O.js";
import { _ as W } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import w from "../Button/index.js";
import he from "../InputContainer/index.js";
import ye from "../List/index.js";
import Ie from "../Popup/index.js";
import Me from "../RawInput/index.js";
import Se from "../../hooks/useBlurEffect.js";
import _e from "../../hooks/useKeyboard.js";
import we from "../../hooks/useTranslation.js";
import { extractInputContainerProps as Pe } from "../../utils/inputs.js";
import be from "./GenericOption/index.js";
const ke = "common", Fe = {
  infoMessageAnd: "and",
  infoMessageMore: "more",
  buttonTitleSelect: "Select all",
  buttonTitleClear: "Clear",
  buttonTitleClose: "Close",
  buttonTitleOpen: "Open",
  selectInputPendingMessage: "Fetching options...",
  selectInputEmptyMessage: "No option available",
  selectInputFilteredMessage: "No option available for the search",
  selectInputErrorMessage: "Could not load options"
}, Re = {
  namespace: ke,
  strings: Fe
}, Te = "_popup_ysmcd_1", Ne = "_list_ysmcd_6", Oe = "_list-item_ysmcd_12", ve = "_info-message_ysmcd_17", xe = "_icon_ysmcd_24", r = {
  popup: Te,
  list: Ne,
  listItem: Oe,
  infoMessage: ve,
  icon: xe
}, De = [];
function Ze($) {
  const {
    actions: j,
    disabled: c,
    readOnly: a,
    required: H,
    ...q
  } = $, [G, U] = Pe(
    q
  ), {
    name: d,
    onOptionClick: P,
    searchText: z,
    onSearchTextChange: b,
    optionContainerClassName: k,
    optionKeySelector: F,
    optionRenderer: R,
    optionRendererParams: T,
    options: J,
    optionsPopupClassName: Q,
    persistentOptionPopup: u,
    placeholder: X,
    valueDisplay: f = "",
    nonClearable: Y,
    onClearButtonClick: Z,
    onSelectAllButtonClick: N,
    optionsPending: O = !1,
    optionsFiltered: ee = !1,
    optionsErrored: v = !1,
    focused: oe,
    focusedKey: C,
    onFocusedKeyChange: g,
    onFocusedChange: x,
    dropdownShown: o,
    onDropdownShownChange: t,
    totalOptionsCount: D = 0,
    hasValue: ne,
    autoFocus: te,
    onEnterWithoutOption: se,
    dropdownHidden: ie
  } = U, h = J ?? De, n = we(Re), E = m(null), K = m(null), y = m(null), V = m(null), re = i(
    (s) => {
      o || t(!0), b(s);
    },
    [
      o,
      t,
      b
    ]
  ), ae = i(
    (s, l) => {
      l.stopPropagation(), t(!o);
    },
    [o, t]
  ), I = i(
    () => {
      o || t(!0);
    },
    [
      o,
      t
    ]
  ), p = i(
    () => {
      t(!1);
    },
    [t]
  ), le = i(
    () => {
      a || I();
    },
    [a, I]
  ), ce = i(
    (s, l) => {
      s || l ? u && y.current && y.current.focus() : p();
    },
    [p, u]
  ), M = i(
    (s, l) => {
      P(s, l, d), u || p();
    },
    [P, p, u, d]
  ), pe = i(
    (s, l) => ({
      contentRendererParam: T,
      option: l,
      optionKey: s,
      focusedKey: C,
      contentRenderer: R,
      onClick: M,
      onFocus: g,
      optionContainerClassName: W(k, r.listItem)
    }),
    [
      C,
      M,
      g,
      k,
      R,
      T
    ]
  );
  Se(
    o,
    ce,
    V,
    E
  );
  const ue = _e(
    C,
    F,
    h,
    o,
    g,
    p,
    I,
    M,
    se
  ), A = h.length, B = D - A > 0 ? `${n.infoMessageAnd} ${D - A} ${n.infoMessageMore}` : void 0, S = o && !ie;
  return /* @__PURE__ */ _(L, { children: [
    /* @__PURE__ */ e(
      he,
      {
        ...G,
        containerRef: E,
        inputSectionRef: K,
        disabled: c,
        readOnly: a,
        required: H,
        actions: /* @__PURE__ */ _(L, { children: [
          j,
          !a && N && /* @__PURE__ */ e(
            w,
            {
              onClick: N,
              disabled: c,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: n.buttonTitleSelect,
              children: /* @__PURE__ */ e(me, { className: r.icon })
            }
          ),
          !a && !Y && ne && /* @__PURE__ */ e(
            w,
            {
              onClick: Z,
              disabled: c,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: n.buttonTitleClear,
              children: /* @__PURE__ */ e(de, { className: r.icon })
            }
          ),
          !a && /* @__PURE__ */ e(
            w,
            {
              onClick: ae,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              disabled: c,
              title: S ? n.buttonTitleClose : n.buttonTitleOpen,
              children: S ? /* @__PURE__ */ e(fe, { className: r.icon }) : /* @__PURE__ */ e(Ce, { className: r.icon })
            }
          )
        ] }),
        input: /* @__PURE__ */ e(
          Me,
          {
            name: d,
            elementRef: y,
            readOnly: a,
            disabled: c,
            value: o || oe ? z : f,
            onChange: re,
            onClick: le,
            onFocus: () => x(!0),
            onBlur: () => x(!1),
            placeholder: ge(f) ? f : X,
            autoComplete: "off",
            onKeyDown: ue,
            autoFocus: te
          }
        )
      }
    ),
    S && /* @__PURE__ */ _(
      Ie,
      {
        elementRef: V,
        parentRef: K,
        className: W(Q, r.popup),
        children: [
          /* @__PURE__ */ e(
            ye,
            {
              className: r.list,
              data: h,
              keySelector: F,
              renderer: be,
              rendererParams: pe,
              errored: v,
              filtered: ee,
              pending: O,
              pendingMessage: n.selectInputPendingMessage,
              emptyMessage: n.selectInputEmptyMessage,
              filteredEmptyMessage: n.selectInputFilteredMessage,
              errorMessage: n.selectInputErrorMessage,
              compact: !0
            }
          ),
          !O && !v && !!B && /* @__PURE__ */ e("div", { className: r.infoMessage, children: B })
        ]
      }
    )
  ] });
}
export {
  Ze as default
};
